import RecipientTransferForm from './RecipientTransferForm'

export default RecipientTransferForm
